import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatFormField } from '@angular/material/form-field';
import { MatTooltip } from '@angular/material/tooltip';
import { ClientConstants } from './../../../../formbird-services/src/lib/constants/ClientConstants';
import { ComponentDefinition } from '@formbird/types';
import { ChangedDocumentService } from 'formbird-services';
import { FormbirdInjectorService } from '@services/injector/formbird-injector.service';
import { debounceTime } from 'rxjs/operators';
import { ComponentSetupService } from '../../../../formbird-sc-shared/src/lib/component-setup.service';
import { AbstractComponent } from '../../../../formbird-sc-shared/src/lib/components/abstract.component';

// extend the ComponentDefinition type with the additional fields for the component
interface RadioListComponentDefinition extends ComponentDefinition {
  radioList?: string[];
  radioItemColumn?: any;
}

@Component({
  templateUrl: './radio-list.component.html',
  styleUrls: ['./radio-list.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class RadioListComponent extends AbstractComponent<RadioListComponentDefinition> implements OnInit {
  isRequired: boolean;
  optionFormGroup: any;

  formControlRadio: any;
  radioItemColumnClass: any;

  constructor(
    protected formbirdInjectorService: FormbirdInjectorService,
    protected changedDocumentService: ChangedDocumentService,
    protected componentSetupService: ComponentSetupService,
    protected cdr: ChangeDetectorRef
  ) {
    super(formbirdInjectorService, changedDocumentService, componentSetupService, cdr);
  }

  ngOnInit() {

    this.formControlRadio = this.componentSetupService.setupStandardComponent(this);

    if (!(typeof this.componentDefinition.mandatory === 'undefined' || this.componentDefinition.mandatory === null)) {
      this.isRequired = this.componentDefinition.mandatory;
    } else {
      this.isRequired = false;
    }


    if (!(typeof this.componentDefinition.radioItemColumn === 'undefined' || this.componentDefinition.radioItemColumn === null)) {
      this.radioItemColumnClass = 'mat-radio-button-' + this.componentDefinition.radioItemColumn;
    } else {
      this.radioItemColumnClass  = 'mat-radio-button-1';
    }

    this.optionFormGroup = new FormGroup({
      formControlRadio: this.formControlRadio
    });

    this.setupChangeDetection();

    const optionSub = this.formControlRadio.valueChanges.pipe(debounceTime(ClientConstants.VALIDATION_INTERVAL_TIME))
      .subscribe(value => {
        this.fieldValue = value;
        this.valueChanged(value);
      });
    this.subs.add(optionSub);

    this.setFieldActivation();

  }

  onFieldValueChanged(fieldValue) {
    if (this.fieldValue === fieldValue) {
      return;
    }

    this.fieldValue = fieldValue;
    this.formControlRadio.patchValue(fieldValue, {emitEvent: false});

    this.detectChanges();
  }

  setFieldActivation(shouldDetectChanges?) {
    if (this.disabled) {
      this.formControlRadio.disable({emitEvent: false});
    } else {
      this.formControlRadio.enable({emitEvent: false});
    }
    this.detectChanges(shouldDetectChanges);
  }

  showToolTip(tooltip: MatTooltip, formFieldContainer: MatFormField, labelContainer: HTMLElement) {
    return (labelContainer.offsetWidth <= formFieldContainer._elementRef.nativeElement.scrollWidth);
  }

  toggleTooltip(tooltip: MatTooltip) {
    setTimeout(() => {
      tooltip.toggle();
    });
  }
}
